import { useForm } from "react-hook-form";
import ControllerSelect from "../../SharedComponents/formComponents/baseFormComponents/ControllerSelect";
import { FontEnum } from "../../SharedComponents/utils/enums/FontEnum";
import { useEffect, useState } from "react";
import ControllerTextInput from "../../SharedComponents/formComponents/baseFormComponents/ControllerTextInput";
import ControllerCheckbox from "../../SharedComponents/formComponents/baseFormComponents/ControllerCheckbox";
import BaseButton from "../../SharedComponents/components/Buttons/BaseButton";
import { ButtonVariantEnum } from "../../SharedComponents/utils/enums/ButtonVariantEnum";
import PlusIconSVG from "../../SharedComponents/assets/icons/svg/PlusIconSVG";
import ControllerDatePicker from "../../SharedComponents/formComponents/baseFormComponents/ControllerDatePicker";
import { OrderPartFormsEnum } from "../utils/enums/OrderPartFormsEnum";
import BaseActionText from "../../SharedComponents/components/ActionText/BaseActionText";
import { getSrcUrlFromFile } from "../../SharedComponents/utils/helpers/getSrcUrlFromFile";
import TrashBinIconSVG from "../assets/icons/svg/TrashBinIconSVG";
import { useDispatch, useSelector } from "react-redux";
import { getGenerationsCar, getMakesCar, getModelsCar, getMotorsCar, resetCombosCar, resetCombosOnGenerationChange, resetCombosOnMakeChange, resetCombosOnModelChange } from "../reduxStore/entities/cars";
import { ulid } from "ulid";
import { createUserCar } from "../reduxStore/entities/userCars";


const AddUserCarForm = ({
    setSelectedForm
}) => {
    const dispatch = useDispatch();

    const makes = useSelector((state) => state.cars.makes);
    const models = useSelector((state) => state.cars.models);
    const generations = useSelector((state) => state.cars.generations);
    const motors = useSelector((state) => state.cars.motors);
    const car_ulid = ulid();



    useEffect(() => {
        const onLoad = () => {
            dispatch(resetCombosCar());
            dispatch(getMakesCar());
        };

        onLoad();
    }, []);


    const [isFormValid, setIsFormValid] = useState(false);

    const [driversLicenceImage, setDriversLicenceImage] = useState(null);
    const [selectedImages, setSelectedImages] = useState([]);


    useEffect(() => {
        const length = selectedImages?.length;

        if (length) {
            if (length > 3) {
                alert('Broj slika ne sme biti veci od 3');
                setSelectedImages((oldVal) => [...oldVal].slice(0, 3));
                return;
            }
        };

    }, [selectedImages]);


    const methods = useForm();
    const { control, getValues, setValue, watch } = methods;


    const values = watch();

    //Handle carMakeId change
    useEffect(() => {
        if (values.carMakeId) {
            dispatch(resetCombosOnMakeChange());
            dispatch(getModelsCar(values.carMakeId));

            setValue("carModelId", "");
            setValue("carGenerationId", "");
            setValue("carEngineId", "");
        };
    }, [values.carMakeId]);

    //Handle carModelId change
    useEffect(() => {
        if (values.carModelId) {
            dispatch(resetCombosOnModelChange());
            dispatch(getGenerationsCar(values.carModelId));

            setValue("carGenerationId", "");
            setValue("carEngineId", "");
        };
    }, [values.carModelId]);

    //Handle carGenerationId change
    useEffect(() => {
        if (values.carGenerationId) {
            dispatch(resetCombosOnGenerationChange());
            dispatch(getMotorsCar(values.carGenerationId));

            setValue("carEngineId", "");
        };
    }, [values.carGenerationId]);


    const GetUnSelectedDriversLicenceImageStack = () => {
        return (
            <div style={styles.vinNumberInputContainer}>
                <ControllerTextInput
                    control={control}
                    name={"vinNumber"}
                    placeholder={"Broj šasije (opciono)"}
                    width={300}
                    styleForInput={{ color: "black" }}
                />

                <p style={styles.baseStyleText}>
                    ili
                </p>

                <BaseActionText
                    onClick={setDriversLicenceImage}
                    text={"Dodajte sliku saobracajne dozvole"}
                    type={"file"}
                />
            </div>
        );
    };



    const GetSelectedImageStack = (file, setState) => {
        return (
            <div style={styles.vinNumberInputContainer}>
                <div style={styles.driversLicenceImageContainer}>
                    <img
                        src={getSrcUrlFromFile(file)}
                        style={styles.diversLicenceImage}
                    />

                    <div
                        onClick={setState}
                        style={styles.trashBinSvgContainer}
                    >
                        <TrashBinIconSVG />
                    </div>
                </div>

            </div>
        );
    };

    const GetSelectedImagesStack = () => {
        return selectedImages.map((file) => {
            const setStateCallback = (oldVal) => {
                return oldVal.filter((oldFile) => oldFile.name !== file.name);
            };

            return GetSelectedImageStack(file, () => setSelectedImages(setStateCallback));
        });
    };


    const handleGiveUp = () => {
        setSelectedForm(OrderPartFormsEnum.ORDER_PART_FORM);
    };

    const handleSubmit = async () => {
        let formData = new FormData();

        formData.append('id_car_make', +values.carMakeId);
        formData.append('id_car_model', +values.carModelId);
        formData.append('id_car_generation', +values.carGenerationId);
        formData.append('id_car_motor', +values.carEngineId);
        formData.append('vin', values.vinNumber);
        formData.append('title', values.carDescription);
        formData.append('ulid', car_ulid);
        formData.append('last_registration_date', values.lastRegistrationDate.toISOString());
        if (values.isParking) {
            formData.append('inGarage', 1);
        } else {
            formData.append('inGarage', 0);
        }

        selectedImages.forEach((image) => {
            formData.append("images", image);
        });


        dispatch(createUserCar(formData));
        setSelectedForm(OrderPartFormsEnum.ORDER_PART_FORM);
    }


    const selectedImagesAreNotEmpty = selectedImages.length > 0;

    return (
        <>
            <div style={styles.mainContainer}>
                <p style={styles.title}>
                    Unesi novi automobil za koji trazis deo
                </p>

                <div style={styles.controllerTextInput}>
                    <ControllerTextInput
                        control={control}
                        name={"carDescription"}
                        placeholder={"Opisni naziv automobila"}
                        width={300}
                        styleForInput={{ color: "black" }}
                    />
                    <p style={styles.formFieldDescText}>
                        Opisite svoj auto radi lakseg pronalazenja
                    </p>
                </div>

                <div style={styles.controllerDatePicker}>
                    <ControllerDatePicker
                        control={control}
                        name={"lastRegistrationDate"}
                        label={"Datum poslednje registracije"}
                    />
                </div>

                <div style={styles.titleComponent}>
                    <p style={styles.title}>
                        Tehnicki podaci
                    </p>
                </div>

                <div style={styles.controllerSelect}>
                    <ControllerSelect
                        control={control}
                        name={"carMakeId"}
                        options={makes.map((make) => ({ label: make.name, value: make.value }))}
                        placeholder={"Marka automobila"}
                        width={300}
                    />

                    <ControllerSelect
                        control={control}
                        name={"carModelId"}
                        options={models.map((model) => ({ label: model.name, value: model.value }))}
                        placeholder={"Model"}
                        width={300}
                        disabled={models.length < 1}
                    />

                    <ControllerSelect
                        control={control}
                        name={"carGenerationId"}
                        options={generations.map((generation) => ({ label: generation.name, value: generation.value }))}
                        placeholder={"Godište / Generacija"}
                        width={300}
                        disabled={generations.length < 1}
                    />

                    <ControllerSelect
                        control={control}
                        name={"carEngineId"}
                        options={motors.map((motor) => ({ label: motor.name, value: motor.value }))}
                        placeholder={"Motor"}
                        width={300}
                        disabled={motors.length < 1}
                    />


                    <div>

                        {
                            driversLicenceImage
                                ? GetSelectedImageStack(driversLicenceImage, () => setDriversLicenceImage(null))
                                : GetUnSelectedDriversLicenceImageStack()
                        }

                        <p style={styles.formFieldDescText}>
                            Omogucava pronalazak tacnog dela
                        </p>
                    </div>
                </div>

                <div style={styles.titleComponent}>
                    <p style={styles.title}>
                        Slike
                    </p>

                    <div style={styles.imageContainer}>
                        {selectedImagesAreNotEmpty && (
                            GetSelectedImagesStack()
                        )}
                    </div>

                </div>


                <BaseButton
                    variant={ButtonVariantEnum.WHITE}
                    text={"Dodaj slike"}
                    IconComponent={PlusIconSVG}
                    type={"file"}
                    onClick={setSelectedImages}
                />


                <div style={styles.controllerCheckBox}>
                    <ControllerCheckbox
                        control={control}
                        name={"isParking"}
                        labelText={"Parkirajte vozilo u garažu za lakšu pretragu delova"}
                    />
                </div>


                <div style={styles.saveOrGiveUpContainer}>

                    <div onClick={() => handleGiveUp()}>
                        <p style={styles.giveUpText}>
                            Odustani
                        </p>
                    </div>

                    <BaseButton
                        onClick={() => handleSubmit()}
                        variant={ButtonVariantEnum.BLACK}
                        text={"Sačuvaj auto"}
                    />

                </div>
            </div>
        </>
    )
};

export default AddUserCarForm;

const styles = {
    mainContainer: {
        marginTop: 30,
    },
    controllerSelect: {
        display: 'flex',
        flexDirection: 'column',
        gap: 15
    },
    controllerCheckBox: {
        marginTop: 40,
        marginBottom: 40
    },
    controllerTextInput: {
        marginTop: 30
    },
    controllerDatePicker: {
        marginTop: 20
    },
    titleComponent: {
        marginTop: 40,
        marginBottom: 30
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "24px",
        fontWeight: 600,
        color: "#000000"
    },
    driversLicenceImageContainer: {
        width: 75,
        height: 75,
        overflow: 'hidden',
        position: 'relative'
    },
    diversLicenceImage: {
        objectFit: 'cover',
        width: "100%",
        height: "100%",
        borderRadius: 4
    },
    trashBinSvgContainer: {
        position: 'absolute',
        cursor: 'pointer',
        backgroundColor: "#FFFFFF",
        bottom: 4,
        right: 4,
        paddingInline: 4,
        borderRadius: 4
    },
    imageContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginTop: 40
    },
    formFieldDescText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de"
    },
    vinNumberInputContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        width: 'max-content'
    },
    purpleText: {
        cursor: "pointer",
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#5B21B6"
    },
    saveOrGiveUpContainer: {
        display: 'flex',
        alignItems: 'center',
        width: 'max-content',
        gap: 40
    },
    giveUpText: {
        cursor: 'pointer',
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 400,
        color: "#5B21B6"
    }
};